
import "./Slider.css"

export default function Slider(props){
    return(
        <div>
            <div className="card">
                <img src={props.image}></img>
                <span>{props.text}</span>
            </div>

        </div>    
        
    )
}